export default __webpack_public_path__ + "static/blackhole-0f5480cb213c886eb4126348a5a95ebf.gif";